import React, { createContext, useContext } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import DashboardLayout from "../DashboardLayout";
import BrandInfo from "../brand/BrandInfo";

export const BrandGateContext = createContext("ready");

export const useBrandGate = () => {
  const { currentProject, loaded: projectsLoaded } = useSelector(
    (state) => state.project,
  );
  const { currentBrand, brands, ready: brandsReady } = useSelector(
    (state) => state.brand,
  );

  if (!projectsLoaded || !brandsReady) {
    return "loading";
  }
  if (!currentProject?.hash) {
    return "no-project";
  }
  if (brands.length === 0) {
    return "needs-brand";
  }
  if (!currentBrand?.hash) {
    return "loading";
  }
  return "ready";
};

export const useBrandGateState = () => useContext(BrandGateContext);

export const RequireBrand = ({ currentUser, children }) => {
  const gate = useBrandGate();

  if (gate === "needs-brand") {
    return (
      <DashboardLayout title="Brand" currentUser={currentUser}>
        <BrandInfo ctaHref="/brand/new/" ctaLabel="Create your first brand" />
      </DashboardLayout>
    );
  }

  return (
    <BrandGateContext.Provider value={gate}>{children}</BrandGateContext.Provider>
  );
};

export const RequireBrandOutlet = ({ currentUser }) => (
  <RequireBrand currentUser={currentUser}>
    <Outlet />
  </RequireBrand>
);

export default RequireBrand;
